<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;width: 100%;min-width:1050px">
      <el-form :inline="true">
        <!-- <el-form-item>
          <el-button type="primary">查询</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="groups" style="width: 100%;min-width:1050px" stripe>
      <el-table-column prop="id" label="id" width="85px" align="center"></el-table-column>
      <el-table-column prop="title" label="用户组" align="left">
        <template slot-scope="scope">
          <el-button type="text" @click="editGroup(scope.row)">{{scope.row.title}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" style="text-align:center" align="center"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span>{{scope.row.status==1?"正常":"禁用"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="authorize(scope.row.id)">访问授权</el-button>
          <el-button
            :type="scope.row.status=='1'?'warning':'success'"
            size="mini"
            @click="editGroupStatue(scope.row.id,scope.row.status=='1'?0:1)"
          >{{scope.row.status=='1'?"禁用":"恢复"}}</el-button>
          <el-button type="danger" size="mini" @click="editGroupStatue(scope.row.id,-1)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--新增/编辑用户组窗口-->
    <el-dialog :title="winTitle" :visible.sync="winAdd" :close-on-click-modal="false" width="400px">
      <div style="margin: 10px 0;">用户组</div>
      <el-input autosize placeholder="请输入用户名" v-model="add.title"></el-input>
      <div style="margin: 20px 0 10px;">描述</div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入描述"
        v-model="add.desc"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCancle">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--用户组访问授权窗口-->
    <el-dialog
      class="dialog"
      title="访问授权编辑"
      width="800px"
      :visible.sync="winRules"
      :close-on-click-modal="false"
    >
      <el-tree
        class="tree"
        ref="tree"
        :data="groupRules"
        show-checkbox
        :expand-on-click-node="false"
        :check-on-click-node="true"
        default-expand-all
        node-key="id"
        :default-checked-keys="groupChecks"
        :props="defaultProps"
      ></el-tree>
      <div slot="footer" class="dialog-footer" style="position: fixed;left: 0; right: 0; bottom: 40px; margin: 0 auto; width:800px; box-sizing: border-box; padding: 20px;">
        <el-button @click.native="rulesCancle">取消</el-button>
        <el-button type="primary" @click.native="rulesSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
//import NProgress from 'nprogress'
import {
  getGroups, //获取用户组列表
  addGroups, //新增用户组
  editGroups, //编辑用户组
  getRules //获取用户组访问授权页
} from "../../api/api";

export default {
  data() {
    return {
      filters: {
        name: ""
      },
      groups: [], //用户组列表

      winAdd: false, //是否打开新增弹窗
      add: { title: "", desc: "" }, //新增弹窗的数据
      isAdd: true, //窗口用于新增或编辑,true为新增
      addLoading: false, //提交窗口是否显示加载态

      gid: null, //需要编辑的用户组
      winRules: false, //用户组规则列表窗口是否打开
      groupRules: [], //用户组规则列表
      groupChecks: [], //用户组默认选中的 id
      defaultProps: {
        children: "child",
        label: "name"
      }
    };
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 ) {
        if (that.winAdd) {
          that.addSubmit();
        } else if (that.winRules) {
          that.rulesSubmit();
        }
        return false;
      }
    };
  },
  methods: {
    //打开新增弹窗
    handleAdd() {
      this.isAdd = true;
      this.winAdd = true;
      this.add = { title: "", desc: "" };
    },
    editGroup(s) {
      this.isAdd = false;
      this.winAdd = true;
      this.add = { group_id: s.id, title: s.title, desc: s.desc };
    },
    //获取用户组列表
    getgroup() {
      getGroups(this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.groups = res.data.data;
        } else {
          this.$message.error("网络请求失败");
        }
      });
    },
    //取消新增弹窗
    addCancle() {
      this.clearAddInfo();
      this.winAdd = false;
    },
    //新增用户组
    addSubmit() {
      if (this.isAdd) {
        var add = { title: this.add.title, desc: this.add.desc };
        addGroups(add, this.$cookie.getCookie("login")).then(res => {
          if (res.data.code == 200) {
            this.getgroup();
            this.$message({ message: "添加成功", type: "success" });
            this.addLoading = false;
            this.winAdd = false;
            this.clearAddInfo();
          } else {
            this.addLoading = false;
            this.$message.error("网络请求失败,请重试");
          }
        });
      } else {
        editGroups(this.add, this.$cookie.getCookie("login")).then(res => {
          if (res.data.code == 200) {
            this.getgroup();
            this.$message({ message: "编辑成功", type: "success" });
            this.addLoading = false;
            this.winAdd = false;
            this.clearAddInfo();
          } else {
            this.addLoading = false;
            this.$message.error("网络请求失败,请重试");
          }
        });
      }
    },
    //清空新增弹窗内容
    clearAddInfo() {
      this.add = { groupName: "", desc: "" };
    },
    //用户组访问授权页
    authorize(gid) {
      this.gid = gid;
      this.groupChecks = [];
      getRules(gid, this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.groupRules = res.data.data;
          this.winRules = true;
          this.fetchCheckedRules(res.data.data);
        }
      });
    },
    //递归遍历需要默认选中的选项
    fetchCheckedRules(arr) {
      var _this = this;
      arr.forEach(v => {
        if (v.child) {
          if (v.child.length > 0) {
            _this.fetchCheckedRules(v.child);
          }
        } else {
          if (v.check == 1) {
            _this.groupChecks.push(v.id);
          }
        }
        // return;
      });
    },
    //取消授权
    rulesCancle() {
      this.winRules = false;
      this.groupChecks = [];
    },
    //提交授权
    rulesSubmit() {
      var rules = [].concat(
        this.$refs.tree.getHalfCheckedKeys(),
        this.$refs.tree.getCheckedKeys()
      ).join(',');
      var edit = {
        group_id: this.gid,
        rules: rules
      };
      editGroups(edit, this.$cookie.getCookie("login")).then(res => {
        if (res.data.code == 200) {
          this.$message({ message: "编辑授权成功", type: "success" });
          this.winRules = false;
          this.groupChecks = [];
        } else {
          this.addLoading = false;
          this.$message.error("网络请求失败,请重试");
        }
      });
    },
    //编辑分组状态
    editGroupStatue(gid, s) {
      var edit = {
        group_id: gid,
        status: s
      };
      if (s == -1) {
        this.$confirm("确认删除该用户吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            editGroups(edit, this.$cookie.getCookie("login")).then(res => {
              if (res.data.code == 200) {
                this.getgroup();
                this.$message({ message: "删除成功", type: "success" });
              } else {
                this.$message.error("网络请求失败,请重试");
              }
            });
          })
          .catch(res => {
            console.error(res);
          });
      } else {
        editGroups(edit, this.$cookie.getCookie("login")).then(res => {
          if (res.data.code == 200) {
            this.getgroup();
            this.$message({
              message: s == 1 ? "启用成功" : "禁用成功",
              type: "success"
            });
          } else {
            this.$message.error("网络请求失败,请重试");
          }
        });
      }
    }
  },
  mounted() {
    this.getgroup();
  },
  computed: {
    winTitle() {
      return this.isAdd ? "新增用户组" : "编辑用户组";
    }
  }
};
</script>

<style >
.el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children {
  padding-left: 54px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
}
.el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node {
  width: 100px;
}
.el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__content {
  padding: 0 40px 0 0 !important;
}
.tree > .el-tree-node > .el-tree-node__content {
  background: #ccc;
}
.tree
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__content {
  background: #eee;
}
</style>


// WEBPACK FOOTER //
// Form.vue?7ecbff22